import Api from '@/services/api.energy';
import FauxData from '@/services/data.service';
import CheckboxFilter from '@/partials/CheckboxFilter';
import OriginElectricityFilter from '@/energy/partials/OriginElectricityFilter';
import RadioFilter from '@/partials/RadioFilter';
import PersonSelector from '@/energy/partials/PersonSelector';
import AddressInput from '@/partials/AddressInput';
import InfoText from '@/partials/InfoText';
import ResultsMetaBar from '@/partials/ResultsMetaBar';
import { eventHub } from '@/services/eventhub';

module.exports = {
	props: ['userAddress', 'viewType', 'targetGroup'],
	components: {
		CheckboxFilter,
		RadioFilter,
		PersonSelector,
		OriginElectricityFilter,
		AddressInput,
		ResultsMetaBar,
		InfoText,
	},
	data() {
		return {
			isLoading: false,
			resultsLoading: false,
			isInitializing: false,
			currentCall: null,
			hasMoreResults: true,
			gasMeterTypes: [
				{
					key: 'G61',
					value: 'G6 < = 10 m³/h (< 500 m³/jaar)',
				},
				{
					key: 'G62',
					value: 'G6 < = 10 m³/h (>= 500 - < 4000 m³/jaar)',
				},
				{
					key: 'G63',
					value: '<= G6 <= 10 m³/h (>= 4000 m³/jaar)',
				},
				{
					key: 'G10',
					value: 'G10 > 10 m³/h - < = 16 m³/h',
				},
				{
					key: 'G161',
					value: 'G16 > 16 m³/h - < = 25 m³/h',
				},
				{
					key: 'G162',
					value: 'G25 > 25 m³/h - < = 40 m³/h',
				},
			],
			electricityMeterTypes: [
				{
					key: 'Stroom3X25A',
					value: '3*25 A',
				},
				{
					key: 'Stroom3X35A',
					value: '3*25 A t/m 3*35 A',
				},
				{
					key: 'Stroom3X50A',
					value: '3*35 A t/m 3*50 A',
				},
				{
					key: 'Stroom3X63A',
					value: '3*50 A t/m 3*63 A',
				},
				{
					key: 'Stroom3X80A',
					value: '3*63 A t/m 3*80 A',
				},
			],

			solarPanelData: {
				wp: 300,
				wpHigh: 210,
				wpLow: 90,
			},
			calculationText:
				'Met deze waardes berekenen wij de de prijzen van de energiepakketten. Controleer of deze overeenkomen met de jaarspecificatie van uw leverancier of meter.',
			userData: {},
			baseFilterData: {
				targetGroup: null,
				PackageType: 'Energy',
				OriginElectricityFilter: null,
				SortFilter: 'TotalExpenses',
				CostDisplayFilter: 'PerMaand',
				SupplierFilter: '',
				CO2compensated: false,
				ContractTypeFilters: ['Fixed'],
			},
			baseUserData: {
				Skip: 0,
				// eslint-disable-next-line
				Take: APP_PAGESIZE,
				targetGroup: '',
				showGuesstimate: true,
				NoBioMassFilter: false,
				Postalcode: '',
				HouseNumber: '',
				HouseNumberAddition: '',
				TypeMeter: null,
				SolarCount: 0,
				// eslint-disable-next-line
				hasRedelivery: APP_HASREDELIVERY_STANDARD,
				HighElectricityConsumption: null,
				LowElectricityConsumption: null,
				HighElectricityDeliveredBack: null,
				LowElectricityDeliveredBack: null,
				ElectricityConnectionType: null,
				GasConnectionType: null,
				noGasConnection: false,
				CurrentSupplier: '',
				resultsOnly: true,
				personCount: 3,
			},
			urlParamsHandeld: false,
			Filters: {},
			isOpened: false,
			showElectricity: true,
			showGas: true,
			// eslint-disable-next-line
			clientName: APP_CLIENTID,
		};
	},

	methods: {
		async updateResults(ignoreSearchData) {
			if (!ignoreSearchData) {
				localStorage.setItem(this.userDataLsKey, JSON.stringify(this.userData));
			}
			let highElectricityConsumption = this.userData.HighElectricityConsumption;
			if (highElectricityConsumption && highElectricityConsumption != '') {
				if (parseInt(highElectricityConsumption) > 100000) {
					this.userData.HighElectricityConsumption = 100000;
				}
			}

			let HighElectricityDeliveredBack = this.userData.HighElectricityDeliveredBack;
			if (HighElectricityDeliveredBack && HighElectricityDeliveredBack != '') {
				if (parseInt(HighElectricityDeliveredBack) > 100000) {
					this.userData.HighElectricityDeliveredBack = 100000;
				}
			}

			let lowElectricityConsumption = this.userData.LowElectricityConsumption;
			if (lowElectricityConsumption && lowElectricityConsumption != '') {
				if (parseInt(lowElectricityConsumption) > 100000) {
					this.userData.LowElectricityConsumption = 100000;
				}
			}

			let LowElectricityDeliveredBack = this.userData.LowElectricityDeliveredBack;
			if (LowElectricityDeliveredBack && LowElectricityDeliveredBack != '') {
				if (parseInt(LowElectricityDeliveredBack) > 100000) {
					this.userData.LowElectricityDeliveredBack = 100000;
				}
			}

			let gasConsumption = this.userData.GasConsumption;
			if (gasConsumption && gasConsumption != '') {
				if (parseInt(gasConsumption) > 100000) {
					this.userData.GasConsumption = 100000;
				}
			}

			this.$emit('newsearchdata', {
				userData: this.userData,
			});
		},

		updateUsage() {
			this.updateResults();
		},
		redeliveryChanged() {
			let solarCount = 0;

			let wp = this.solarPanelData.wp;
			let totalRedelivery =
				parseInt(this.userData.HighElectricityDeliveredBack, 10) +
				parseInt(this.userData.LowElectricityDeliveredBack, 10);
			solarCount = parseInt(totalRedelivery / wp);
			this.userData.SolarCount = solarCount;
			this.updateResults();
		},
		setAddress(address) {
			this.userData.Postalcode = address.Postalcode;
			this.userData.HouseNumber = address.HouseNumber;
			this.userData.HouseNumberAddition = address.HouseNumberAddition;
			this.updateResults();
		},
		setUsageFromSelector(usage) {
			this.userData.personCount = usage.personCount;
			this.userData.HighElectricityConsumption = usage.elec;
			this.userData.GasConsumption = usage.gas;
			this.updateResults();
		},
		setOriginFilter(data) {
			this.userData.OriginElectricityFilter = data.origin;
			this.userData.NoBioMassFilter = data.NoBioMassFilter;
			this.updateResults();
		},

		setContractTypeFilters(contractTypes) {
			let selectedContractTypes = contractTypes.split(',');
			this.userData.ContractTypeFilters = selectedContractTypes;

			this.updateResults();
		},

		setSupplierFilter(suppliers) {
			this.userData.SupplierFilter = suppliers;
			this.updateResults();
		},
		updateButtonClicked() {
			this.updateResults();
			this.isOpened = false;
		},
		toggleRedelivery() {
			if (!this.userData.hasRedelivery) {
				this.userData.SolarCount = 0;
			}
			this.setRedelivery();
			this.updateResults();
		},

		setRedelivery(doUpdate) {
			let solarCount = this.userData.SolarCount;
			if (this.userData.TypeMeter === 'double') {
				let wpHigh = solarCount * this.solarPanelData.wpHigh;
				this.userData.HighElectricityDeliveredBack = parseInt(wpHigh, 10);
				let wpLow = solarCount * this.solarPanelData.wpLow;
				this.userData.LowElectricityDeliveredBack = parseInt(wpLow, 10);
			} else {
				let wp = solarCount * this.solarPanelData.wp;
				this.userData.HighElectricityDeliveredBack = parseInt(wp, 10);
				this.userData.LowElectricityDeliveredBack = 0;
			}
			if (doUpdate) {
				if (window.solarTimer) {
					clearTimeout(window.solarTimer);
				}
				window.solarTimer = setTimeout(() => {
					this.updateResults();
				}, 700);
			}
		},
		toggleGuesstimate(doUpdate = true) {
			this.userData.showGuesstimate = !this.userData.showGuesstimate;
			if (this.userData.showGuesstimate) {
				this.userData.TypeMeter = 'single';
			}
			this.setTypeMeterProps();
			if (doUpdate) {
				this.updateResults();
			}
		},
		toggleGasConnection() {
			if (this.userData.noGasConnection) {
				this.userData.GasConsumption = 0;
			} else {
				if (this.targetGroup === 'Business') {
					this.userData.GasConsumption = 5500;
				} else {
					this.userData.GasConsumption = 1500;
				}
			}
			this.updateResults();
		},
		toggleTypeMeter() {
			this.userData.TypeMeter = this.userData.TypeMeter === 'double' ? 'single' : 'double';
			this.setRedelivery();
			this.setTypeMeterProps();
		},
		setTypeMeterProps() {
			if (this.userData.TypeMeter === 'double') {
				this.userData.LowElectricityConsumption = parseInt(this.userData.HighElectricityConsumption * 0.4);
				this.userData.HighElectricityConsumption =
					parseInt(this.userData.HighElectricityConsumption) -
					(this.userData.LowElectricityConsumption ? this.userData.LowElectricityConsumption : 0);
			} else {
				this.userData.HighElectricityConsumption =
					parseInt(this.userData.HighElectricityConsumption) +
					parseInt(this.userData.LowElectricityConsumption ? this.userData.LowElectricityConsumption : 0);
				this.userData.LowElectricityConsumption = 0;
			}
			this.updateResults();
		},
		setMetaOptions(data) {
			this.userData.CostDisplayFilter = data.costDisplay;
			this.userData.SortFilter = data.sortOption;

			this.updateResults();
		},
		scrollToAnchor(anchor) {
			let element = document.getElementById(anchor);
			if (element) {
				element.scrollIntoView();
			}
		},
		resetFormData() {
			localStorage.removeItem(this.userDataLsKey);
			this.userData = Object.assign({}, this.baseUserData, this.baseFilterData);
			window.location.reload();
		},
		resetFilters() {
			this.userData = Object.assign({}, this.userData, this.baseFilterData);
			this.storageSetObject(this.userData, this.userDataLsKey);
			window.location.reload();
		},
		toggleOpened() {
			this.isOpened = !this.isOpened;
		},
		proceedToComparison() {
			// eslint-disable-next-line
			let hasExternalComparisonPage = APP_HASEXTERNALCOMPARISONPAGE;

			if (!hasExternalComparisonPage) {
				let comparisonPageUrl =
					// eslint-disable-next-line
					this.targetGroup === 'Business' ? APP_COMPARISONPAGE_BUSINESS : APP_COMPARISONPAGE;
				this.storageSetObject(this.userData, this.userDataLsKey);
				this.goToUrl(comparisonPageUrl);
			} else {
				// eslint-disable-next-line
				let externalComparisonPage = APP_EXTERNALCOMPARISONPAGE;
				let urlParams = [];
				if (this.userData.HighElectricityConsumption) {
					urlParams.push(`stroomhoogverbruik=${this.userData.HighElectricityConsumption}`);
				}
				if (this.userData.LowElectricityConsumption) {
					urlParams.push(`stroomlaagverbruik=${this.userData.LowElectricityConsumption}`);
				}
				if (this.userData.HighElectricityDeliveredBack) {
					urlParams.push(`terugstroomhoog=${this.userData.HighElectricityDeliveredBack}`);
				}
				if (this.userData.LowElectricityDeliveredBack) {
					urlParams.push(`terugstroomlaag=${this.userData.LowElectricityDeliveredBack}`);
				}
				if (this.userData.GasConsumption) {
					urlParams.push(`gasverbruik=${this.userData.GasConsumption}`);
				}
				if (this.userData.TypeMeter) {
					urlParams.push(`typemeter=${this.userData.TypeMeter.toLowerCase()}`);
				}

				if (this.userData.Postalcode) {
					urlParams.push(`postal=${this.userData.Postalcode}`);
				}
				if (this.userData.HouseNumber) {
					urlParams.push(`housenr=${this.userData.HouseNumber}`);
				}
				if (this.userData.HouseNumberAddition) {
					urlParams.push(`housenradditional=${this.userData.HouseNumberAddition}`);
				}
				if (this.userData.CurrentSupplier) {
					urlParams.push(`huidigeleverancier=${this.userData.CurrentSupplier}`);
				}

				let urlParamsString = urlParams
					.map((s) => {
						let [key, value] = s.split('=');
						return `${key}=${encodeURIComponent(value)}`;
					})
					.join('&');
				externalComparisonPage = `${externalComparisonPage}&${urlParamsString}`;
				window.location.href = externalComparisonPage;
			}
		},
	},
	async mounted() {
		this.isInitializing = true;
		this.userDataLsKey = this.targetGroup === 'Business' ? 'userDataBusiness' : 'userData';
		this.isLoading = true;
		let userData = this.storageGetObject(this.userDataLsKey);

		if (!this.urlParamsHandeld) {
			let urlParams = this.getUrlParams();
			if (urlParams.filter((i) => i.key === 'productid').length > 0) {
				// show form
				let urlParameters = urlParams.map((key) => key.key + '=' + key.value).join('&');
				let productId = urlParams.find((i) => i.key === 'productid').value;
				let formData = {
					UrlParams: urlParameters,
					SerialId: productId,
				};
				setTimeout(function () {
					eventHub.$emit('show-form', formData);
				}, 1000);
			}
			if (urlParams.filter((i) => i.key === 'postal' || i.key === 'housnr').length > 0) {
				if (!userData) {
					userData = {};
				}
				urlParams.forEach((param) => {
					let key = param.key;
					let value = param.value;
					if (key === 'typemeter') {
						if (value == '1') {
							value = 'single';
						}
						if (value == '2') {
							value = 'double';
						}
					}
					let meterType, gasMeterType;
					switch (key) {
						case 'stroomhoogverbruik':
							userData.HighElectricityConsumption = value;
							userData.showGuesstimate = false;
							break;
						case 'stroomlaagverbruik':
							userData.LowElectricityConsumption = value;
							userData.showGuesstimate = false;
							break;
						case 'terugstroomhoog':
							userData.HighElectricityDeliveredBack = value;
							userData.showGuesstimate = false;
							break;
						case 'terugstroomlaag':
							userData.LowElectricityDeliveredBack = value;
							userData.showGuesstimate = false;
							break;
						case 'gasverbruik':
							userData.GasConsumption = value;
							userData.showGuesstimate = false;
							break;
						case 'typemeter':
							userData.TypeMeter = value;
							userData.showGuesstimate = false;
							break;
						case 'postal':
							userData.Postalcode = value;
							break;
						case 'housenr':
							userData.HouseNumber = value;
							break;
						case 'housenradditional':
							userData.HouseNumberAddition = value;
							break;
						case 'huidigeleverancier':
							userData.CurrentSupplier = value;
							break;
						case 'typestroomaansluiting':
							meterType = this.electricityMeterTypes.find(
								(eMT) => eMT.key.toLowerCase() == value.toLowerCase()
							);
							if (meterType) {
								userData.ElectricityConnectionType = meterType.key;
							} else {
								console.log("Could't find key for", value, 'in', this.electricityMeterTypes);
							}
							// console.log(
							// 	userData.ElectricityConnectionType,
							// 	value,
							// 	this.electricityMeterTypes.filter((eMT) => eMT.key.toLowerCase() == value.toLowerCase())
							// );
							break;
						case 'typegasaansluiting':
							gasMeterType = this.gasMeterTypes.find(
								(gMT) => gMT.key.toLowerCase() == value.toLowerCase()
							);
							if (gasMeterType) {
								userData.GasConnectionType = gasMeterType.key;
							} else {
								console.log("Could't find key for", value, 'in', this.gasMeterTypes);
							}
							break;
					}
				});
			}
		}
		if (this.targetGroup === 'Business') {
			this.baseUserData.ElectricityConnectionType = this.electricityMeterTypes[2].key;
			this.baseUserData.GasConnectionType = this.gasMeterTypes[2].key;
			this.baseUserData.HighElectricityConsumption = 23000;
			this.baseUserData.GasConsumption = 5500;

			this.baseFilterData.ContractTypeFilters = '';
		}
		this.userData.resultsOnly = !this.isDetailPage;

		this.userData = userData ? userData : Object.assign({}, this.baseUserData, this.baseFilterData);

		// eslint-disable-next-line
		if (this.isSmallView && APP_CLIENTID === 'soc' && 2 == 3) {
			if (this.userData.hasRedelivery && this.userData.SolarCount == 0) {
				this.toggleGuesstimate(false);
				this.toggleTypeMeter();
				this.userData.LowElectricityConsumption = 1400;
				this.userData.HighElectricityConsumption = 2100;
				this.userData.GasConsumption = 1500;
				this.userData.SolarCount = 10;
				this.setRedelivery(false);
			}
		}
		this.userData.targetGroup = this.targetGroup;
		let apiData = await Api.getResults({
			...this.userData,
			resultsOnly: false,
		});

		let filters = apiData.Filters;

		if (this.userData) {
			if (this.userData.ContractTypeFilters && this.userData.ContractTypeFilters != '') {
				filters.ContractType.forEach((tV) => {
					tV.IsSelected = this.userData.ContractTypeFilters.indexOf(tV.Value) > -1;
				});
			}

			if (this.userData.OriginElectricityFilter && this.userData.OriginElectricityFilter != '') {
				filters.OriginElectricity.forEach((oE) => {
					oE.IsSelected = this.userData.OriginElectricityFilter === oE.Value;
				});
			}
			if (this.userData.SortFilter && this.userData.SortFilter != '') {
				filters.Sort.forEach((s) => {
					s.IsSelected = this.userData.SortFilter === s.Value;
				});
			}

			if (this.userData.CostDisplayFilter && this.userData.CostDisplayFilter != '') {
				filters.CostDisplay.forEach((cD) => {
					cD.IsSelected = this.userData.CostDisplayFilter === cD.Value;
				});
			}
			if (this.userData.SupplierFilter && this.userData.SupplierFilter != '') {
				filters.Suppliers.forEach((rS) => {
					rS.IsSelected = this.userData.SupplierFilter.indexOf(rS.Value) > -1;
				});
			}
		} else {
			this.userData = Object.assign({}, this.baseUserData, this.baseFilterData);
			filters.ContractDuration[0].IsSelected = true;
		}

		this.Filters = filters;
		this.Filters.RichSuppliers = FauxData.fauxSuppliers;

		this.Filters.RichSuppliers.push(...filters.Suppliers);
		this.Filters.RichSuppliers.forEach((item, index) => {
			item.Id = index;
			item.Key = index;
		});
		if (typeof this.userData === 'string' && this.userData.indexOf('Object]') > -1) {
			this.userData = Object.assign({}, this.baseUserData, this.baseFilterData);
		}

		this.userData.targetGroup = this.targetGroup;
		this.userData.PackageType = this.userData.noGasConnection ? 'Electricity' : 'Energy';
		this.$emit('newsearchdata', {
			userData: this.userData,
			doneInitializing: true,
		});
	},
	computed: {
		isSmallView: function () {
			return this.viewType && this.viewType === 'vertical';
		},
		hasEnergyConsumption() {
			let hasHighConsumption =
				this.userData.HighElectricityConsumption != null &&
				this.userData.HighElectricityConsumption != '' &&
				this.userData.HighElectricityConsumption != '0';
			let hasLowConsumption =
				this.userData.LowElectricityConsumption != null &&
				this.userData.LowElectricityConsumption != '' &&
				this.userData.LowElectricityConsumption != '0';
			return hasHighConsumption || hasLowConsumption;
		},
	},
};
